import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_update_agency_main_sales_rep: { message: "idle" },
};

export const tenant_update_agency_main_sales_rep_Slice = createSlice({
 name: "tenant_update_agency_main_sales_rep",
 initialState,
 reducers: {
  success_tenant_update_agency_main_sales_rep: (state, action) => {
   state.tenant_update_agency_main_sales_rep = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_update_agency_main_sales_rep: (state, action) => {
   state.tenant_update_agency_main_sales_rep = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_update_agency_main_sales_rep: (state) => {
   state.tenant_update_agency_main_sales_rep = { status: app_consts.IDLE };
  },
  loading_tenant_update_agency_main_sales_rep: (state) => {
   state.tenant_update_agency_main_sales_rep = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_update_agency_main_sales_rep, fail_tenant_update_agency_main_sales_rep, reset_tenant_update_agency_main_sales_rep, loading_tenant_update_agency_main_sales_rep } = tenant_update_agency_main_sales_rep_Slice.actions;

export default tenant_update_agency_main_sales_rep_Slice.reducer;